import { Box, MenuItem, Select } from '@mui/material';
import React from 'react';
import { useAuthStore } from '../../../store/storeAuth';
import { getAllProviders } from '../registry';
import Label from '../../UI/Label/Label';

interface ProviderSelectorProps {
  value: string;
  onChange: (providerId: string) => void;
  disabled?: boolean;
}

const ProviderSelector: React.FC<ProviderSelectorProps> = ({
  value,
  onChange,
  disabled,
}) => {
  const { user } = useAuthStore(state => state);
  const providers = getAllProviders();

  const selectSx = {
    width: '100%',
    maxWidth: '360px',
    '& .MuiList-root': {
      backgroundColor: user?.theme === 'dark' ? '#101828' : '#F9FAFB',
    },
    '& .MuiSvgIcon-root': {
      color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
    },
    borderRadius: '8px',
    border: 'none',
    boxShadow: 'none',
    '.MuiOutlinedInput-notchedOutline': { border: 0 },
    bgcolor: user?.theme === 'dark' ? '#101828' : '#F9FAFB',
    color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
  };

  const menuPropsSx = {
    PaperProps: {
      sx: {
        '& .Mui-selected': {
          backgroundColor: user?.theme === 'dark' ? '#667085' : '#D0D5DD',
        },
        backgroundColor: user?.theme === 'dark' ? '#1D2939' : '#F9FAFB',
      },
    },
  };

  if (providers.length === 0) {
    return (
      <>
        <Label labelName="Provider" isAdvanced />
        <span style={{ fontSize: '12px', color: '#98A2B3' }}>
          No integrations registered. Add a provider config and register it.
        </span>
      </>
    );
  }

  const displayValue = value || providers[0]?.id;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <Label
        labelName="Provider"
        isAdvanced
        sx={{ mb: 0 }}
        labelStyle={{
          fontSize: '14px',
          color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
          fontWeight: 400,
        }}
      />
      <Select
        className="nodrag"
        value={displayValue}
        onChange={e => onChange(e.target.value as string)}
        disabled={disabled}
        sx={selectSx}
        MenuProps={menuPropsSx}
        renderValue={val => {
          const p = providers.find(pr => pr.id === val);
          return p?.name ?? val;
        }}
      >
        {providers.map(provider => (
          <MenuItem
            key={provider.id}
            value={provider.id}
            sx={{ color: user?.theme === 'dark' ? '#D0D5DD' : 'black' }}
          >
            {provider.name}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default ProviderSelector;
